exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".files {\n    display: none;\n}\n.fa {\n   font-size: x-large;\n   padding-right: 50px;\n}\n.errorMessage{\n    color: red;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/agira/Desktop/BU-Intra/agira-intranet-ui/src/app/reimbursement/reimbursement-add-form/reimbursement-add-form.component.css
// module id = ../../../../../src/app/reimbursement/reimbursement-add-form/reimbursement-add-form.component.css
// module chunks = main